import { createReducer } from '@reduxjs/toolkit';
import { arrayUnique } from 'common/utilities/core/array';
import { clearConfirmation,showConfirmation } from 'core/redux/actions/confirmation/confirmationAction';
import {
  activateEditableTableAction,
  closeFullscreenTableAction,
  closeModalAction,   deactivateEditableTableAction,
  disableLegacySearchAction,
  hideAppHeaderEnvAction,
openFullscreenTableAction,
  redirectToPageAction,
  refreshPageAction,
resetCloseModalAction,   resetRedirectToPageAction,
  resetRefreshPageAction,
  showAppHeaderEnvAction,
startResizingTableColumnAction,
  stopResizingTableColumnAction, } from 'core/redux/actions/ui/uiActions';

import type { UIState } from './uiReducer.types';

const initialState: UIState = {
  refreshPage: false,
  showAppHeaderEnv: false,
  legacySearch: true,
  editableTables: [],
};

const uiReducer = createReducer(initialState, (builder) => builder

  .addCase(activateEditableTableAction, (state, action) => (
    { ...state, editableTables: arrayUnique([...state.editableTables, action.payload.tableId]) }
  ))

  .addCase(deactivateEditableTableAction, (state, action) => (
    { ...state, editableTables: state.editableTables.filter((t) => t !== action.payload.tableId) }
  ))

  .addCase(disableLegacySearchAction, (state) => (
    { ...state, legacySearch: false }
  ))

  .addCase(startResizingTableColumnAction, (state, action) => (
    { ...state, resizingTableColumn: action.payload.columnId }
  ))

  .addCase(stopResizingTableColumnAction, (state) => (
    { ...state, resizingTableColumn: undefined }
  ))

  .addCase(closeModalAction, (state, action) => (
    { ...state, closeModal: action.payload.modalId || 'all' }
  ))

  .addCase(resetCloseModalAction, (state) => (
    { ...state, closeModal: undefined }
  ))

  .addCase(refreshPageAction, (state) => (
    { ...state, refreshPage: true }
  ))

  .addCase(resetRefreshPageAction, (state) => (
    { ...state, refreshPage: false }
  ))

  .addCase(redirectToPageAction, (state, action) => (
    { ...state, redirectToPage: action.payload }
  ))

  .addCase(resetRedirectToPageAction, (state) => (
    { ...state, redirectToPage: undefined }
  ))

  .addCase(openFullscreenTableAction, (state, action) => (
    { ...state, fullscreenTable: action.payload.tableId }
  ))

  .addCase(closeFullscreenTableAction, (state) => (
    { ...state, fullscreenTable: undefined }
  ))

  .addCase(showAppHeaderEnvAction, (state) => (
    { ...state, showAppHeaderEnv: true }
  ))

  .addCase(hideAppHeaderEnvAction, (state) => (
    { ...state, showAppHeaderEnv: false }
  ))

  .addCase(showConfirmation, (state, action) => (
    { ...state, confirmation: action.payload.confirmation }
  ))

  .addCase(clearConfirmation, (state) => (
    { ...state, confirmation: undefined }
  )));

export default uiReducer;
